import {
  BookMarked,
  Brain,
  Calculator,
  Droplets,
  Dumbbell,
  Flame,
  FlaskConical,
  HeartPulse,
  LineChart,
  Luggage,
  MapPin,
  Pill,
  Plane,
  Sparkles,
  Stethoscope,
  Syringe
} from 'lucide-react'
import type { ValueStackItem } from '../types/content'

export const valueStack: ValueStackItem[] = [
  {
    id: 'ebook',
    icon: BookMarked,
    title: 'Ebook Maestro: Protocolo Lujo de Farmacia',
    detail: 'El sistema de operaciones completo',
    value: 197,
    isCore: true
  },
  {
    id: 'bonus-1',
    icon: MapPin,
    title: 'Bonus 1: La Lista Negra de Farmacias 2026',
    detail: 'Ubicaciones VIP verificadas',
    value: 97
  },
  {
    id: 'bonus-2',
    icon: Calculator,
    title: 'Bonus 2: Calculadora de "Clicks" Luxe',
    detail: 'Precisión quirúrgica en cada dosis',
    value: 67
  },
  {
    id: 'bonus-3',
    icon: Plane,
    title: 'Bonus 3: Protocolo "Jet-Lag" Elite',
    detail: 'Recuperación de viajes',
    value: 47
  },
  {
    id: 'bonus-4',
    icon: Syringe,
    title: 'Bonus 4: Guía de Inyección Invisible',
    detail: 'Cero marcas, cero dolor',
    value: 47
  },
  {
    id: 'bonus-5',
    icon: LineChart,
    title: 'Bonus 5: Diario de Biomarcadores',
    detail: 'Métricas pro de seguimiento',
    value: 37
  },
  {
    id: 'bonus-6',
    icon: Flame,
    title: 'Bonus 6: Cheat Sheet Péptidos para Grasa',
    detail: 'Lipólisis flash',
    value: 37
  },
  {
    id: 'bonus-7',
    icon: HeartPulse,
    title: 'Bonus 7: Protocolo de Libido y Vitalidad',
    detail: 'Vigor de los 20s',
    value: 97
  },
  {
    id: 'bonus-8',
    icon: Droplets,
    title: 'Bonus 8: Guía de Agua Bacteriostática',
    detail: 'Seguridad y manejo',
    value: 27
  },
  {
    id: 'bonus-9',
    icon: FlaskConical,
    title: 'Bonus 9: Directorio de Laboratorios Certificados',
    detail: 'Pureza comprobada',
    value: 67
  },
  {
    id: 'bonus-10',
    icon: Sparkles,
    title: 'Bonus 10: Protocolo Piel de Porcelana',
    detail: 'GHK-Cu Luxe',
    value: 47
  },
  {
    id: 'bonus-11',
    icon: Luggage,
    title: 'Bonus 11: Checklist de Viaje Seguro',
    detail: 'Aduanas y TSA',
    value: 47
  },
  {
    id: 'bonus-12',
    icon: Brain,
    title: 'Bonus 12: Stack de Nootrópicos',
    detail: 'Enfoque Limitless',
    value: 67
  },
  {
    id: 'bonus-13',
    icon: Dumbbell,
    title: 'Bonus 13: Rutina de Entrenamiento Pro-Péptidos',
    detail: 'Sinergia de estímulo',
    value: 47
  },
  {
    id: 'bonus-14',
    icon: Pill,
    title: 'Bonus 14: Guía de Suplementos Sinérgicos',
    detail: 'Cofactores esenciales',
    value: 27
  },
  {
    id: 'bonus-15',
    icon: Stethoscope,
    title: 'Bonus 15: Directorio de Telemedicina',
    detail: 'Respaldo médico legal',
    value: 97
  }
]

export const totalValue = 1123
export const todayPrice = 37
export const listPrice = 197
